(ns superadmin.resource.workspace
  (:require [common.queries.http :as qhttp]))

(defn workspace-mappings-query []
  #js {:queryKey #js ["workspace-mappings"]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/os-workspace-mappings {})))
       :staleTime (* 60 1000)})
